import styled from 'styled-components';
import { colours, media, spacing } from '../../stylings';

export const Select = styled.select`
  all: unset;
  font-size: 16px;
  padding: ${spacing.XS} ${spacing.XXXS};
  width: 100%;

  &:focus {
    outline: 2px solid ${colours.OUTLINE_BORDER};
    width: 97%;
  }
`;

export const SelectLabel = styled.label`
  background-color: ${colours.WHITE};
  font-size: 12px;
  font-weight: 200;
  left: ${spacing.XXXXS};
  line-height: 12px;
  padding: 0 ${spacing.XXXXS};
  position: absolute;
  top: 0;
  transform: translateY(-50%);
  white-space: nowrap;
`;

export const SelectWrapper = styled.div<{ isFocused?: boolean }>`
  border: 1px solid ${colours.BLACK};
  height: fit-content;
  max-height: 44px;
  min-height: 44px;
  position: relative;
  /* NOTE: This is being used since :focus and :focus-visible are not working on the select element */
  ${({ isFocused }) => isFocused && `outline: 2px solid ${colours.OUTLINE_BORDER};`}
  @media ${media.greaterThan('lg')} {
    min-height: 50px;
  }
`;

export const PhoneNumberSelectWrapper = styled(SelectWrapper)`
  min-width: 150px;
`;

export const SelectArrowWrapper = styled.div`
  pointer-events: none;
  position: absolute;
  right: ${spacing.XXXS};
  top: 50%;
  transform: translateY(-50%);
`;

export const PhoneNumberValue = styled.div`
  padding: ${spacing.XXS} ${spacing.XXXS};
`;

export const PhoneNumberContainer = styled.div`
  display: flex;

  > :first-child {
    border: 1px solid ${colours.GREY};
    border-right: none;
    width: 92px;

    select {
      border: none;
      bottom: -2px;
      filter: alpha(opacity=0);
      height: 100%;
      left: 0;
      min-height: 100%;
      opacity: 0;
      padding: ${spacing.XXS} ${spacing.XXXS};
      position: absolute;
      right: 0;
      top: 0;
      width: 100%;
    }
  }

  > :last-child {
    width: calc(100% - 92px);
  }
`;
